module.exports = __webpack_public_path__ + "img/ahmedabd-img.77515c14.jpg";